import SingleSigner from "./components/signer";

function SignSinglePage(): React.JSX.Element {
  return <SingleSigner />;
}

export default SignSinglePage;
